import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import { User } from 'types/api/users.type';

import * as S from './Zone.styles';

export const useColumns = (onClick: (arg: string, user?: User) => void, user?: User) =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Zone',
        columns: [
          {
            Header: 'Zone',
            accessor: 'zone',
          },
          {
            Header: '',
            accessor: 'id',
            Cell: ({ value }) => (
              <S.ButtonRemove
                onClick={() => onClick(value, user)}
                iconLeft="FiX"
                motive="primaryBlack"
              />
            ),
          },
        ],
      },
    ],
    [user]
  );
